import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "edit-participant-button d-flex justify-content-end" }

import { useStore } from '@/store'

  // Config
  import { ModalId } from '@/config/modalIds'

  // Translations
  import { useI18n } from 'vue-i18n'
  
export default /*@__PURE__*/_defineComponent({
  __name: 'EditTravellersButton',
  setup(__props) {



  // Store
  const { t } = useI18n()

  const store = useStore()

  // Methods
  const openPanel = (): void => {
    store.commit('modal/open', ModalId.TRAVELLER_PANEL)
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "button-primary primary-normal small action-button col-12 col-md-10",
      onClick: openPanel
    }, _toDisplayString(_unref(t)('travellers.modifyInformation')), 1)
  ]))
}
}

})